import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem } from '@/components/ui/dropdown-menu';
import { toast } from '@/components/ui/sonner';
import { useLocale } from '@/lib/locale';
import { translate } from '@/lib/localeMessages';
import { LANGUAGES } from '@/lib/region';

export const LanguageSwitcher = ({ id = 'language-switcher', compact = false }) => {
 const { language, t, setLanguage } = useLocale();
 const [busy, setBusy] = useState(false);
 const change = async (value) => {
   if (busy || value === language) return;
   setBusy(true);
   try { await setLanguage(value); toast.success(translate('Language updated', value)); }
   catch { toast.error(t('Could not save your language. Please try again.')); }
   finally { setBusy(false); }
 };
 return <DropdownMenu><DropdownMenuTrigger asChild><Button variant="outline" size="sm" className="min-h-11 shrink-0 gap-2" disabled={busy} aria-label={t('Choose your language')} data-testid={`${id}-trigger`}><Languages className="h-4 w-4" aria-hidden="true" /><span className={compact ? 'hidden sm:inline' : ''}>{LANGUAGES.find((item) => item.code === language)?.name || 'English'}</span></Button></DropdownMenuTrigger>
 <DropdownMenuContent align="end" data-testid={`${id}-menu`}><DropdownMenuRadioGroup value={language} onValueChange={change}>{LANGUAGES.map((item) => <DropdownMenuRadioItem className="min-h-11" key={item.code} value={item.code} disabled={busy} lang={item.code === 'tl' ? 'fil' : item.code} data-testid={`${id}-option-${item.code}`}>{item.name}</DropdownMenuRadioItem>)}</DropdownMenuRadioGroup></DropdownMenuContent></DropdownMenu>;
};

export const BookingLanguageBar = () => {
 const location = useLocation();
 if (!/^\/(coach|pay-invoice|enrollment-invite|parent\/invite)(\/|$)/.test(location.pathname)) return null;
 return <div className="flex justify-end border-b border-border bg-background px-4 py-2" data-testid="booking-language-bar"><LanguageSwitcher id="booking-language" /></div>;
};
